import { compact } from "lodash";
import { baseUrl } from "./baseUrl";

export const getUsersRoute = (page) => {
  const query = page !== undefined ? `users?page=${page}&size=200` : "";
  return compact([`${baseUrl}`, "security-api", query]).join("/");
};
export const getCreateUserRoute = () => [`${baseUrl}`, "security-api", "users"].join("/");
export const getDeleteUserRoute = (userId) =>
  [`${baseUrl}`, "security-api", "users", userId].join("/");
export const getUsersPageableSearchRoute = (searchItem, page = 0, size = 20) => {
  const { lastName, firstName, login, email } = searchItem;
  let searchQuery = "pageable-search?";
  if (lastName) {
    searchQuery += `lastName=${lastName}&`;
  }
  if (firstName) {
    searchQuery += `firstName=${firstName}&`;
  }
  if (login) {
    searchQuery += `login=${login}&`;
  }
  if (email) {
    searchQuery += `email=${encodeURIComponent(email)}&`;
  }
  return [`${baseUrl}`, "security-api", "users", `${searchQuery}page=${page}&size=${size}`].join(
    "/"
  );
};
export const getUserByIdRoute = (userId) =>
  [`${baseUrl}`, "security-api", "users", userId].join("/");
export const getPermissionsRoute = (page = 0, size = 20) =>
  [`${baseUrl}`, "security-api", `permissions?page=${page}&size=${size}`].join("/");
export const getAssignPermissionsRoute = (userId, permissionsArr) =>
  [
    `${baseUrl}`,
    "security-api",
    "users",
    `${userId}`,
    `permissions?include=${encodeURIComponent(permissionsArr)}`,
  ].join("/");
export const getRolesRoute = (page = 0, size = 20) =>
  [`${baseUrl}`, "security-api", `roles?page=${page}&size=${size}`].join("/");
export const getAssignRolesRoute = (userId, rolesArr) =>
  [
    `${baseUrl}`,
    "security-api",
    "users",
    `${userId}`,
    `roles?include=${encodeURIComponent(rolesArr)}`,
  ].join("/");
export const getBlockRolesRoute = (userId, rolesArr) =>
  [
    `${baseUrl}`,
    "security-api",
    "users",
    `${userId}`,
    `roles?exclude=${encodeURIComponent(rolesArr)}`,
  ].join("/");
export const getBlockPermissionsRoute = (userId, permissionsArr) =>
  [
    `${baseUrl}`,
    "security-api",
    "users",
    `${userId}`,
    `permissions?exclude=${encodeURIComponent(permissionsArr)}`,
  ].join("/");
export const getCurrentUserRoute = () => [`${baseUrl}`, "security-api", "users", "me"].join("/");
